"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
function LocationIcon(props) {
    return (react_1.default.createElement(SvgIcon_1.default, __assign({}, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 96 96" },
            react_1.default.createElement("path", { fill: "none", d: "M-1-1h582v402H-1z" }),
            react_1.default.createElement("g", null,
                react_1.default.createElement("path", { d: "M54.07 14.88A21.52 21.52 0 0045 14.2c-10 1.29-18.26 10.22-18.26 20.25 0 15.63 19.13 34.27 21.17 47.55 2-13.28 21.35-32.69 21.35-47.11a21.15 21.15 0 00-15.19-20.01zM48 44.41a9 9 0 119-9.06 9 9 0 01-9 9.06z" }))),
        " "));
}
exports.default = LocationIcon;
